import { CLEAR_PROFILE, FETCH_PROFILE, SET_PROFILE } from "../actions";

export const getProfile = () => ({
    type: FETCH_PROFILE,
});

export const setProfile = (profileData) => ({
    type: SET_PROFILE,
    payload: profileData,
});

export const clearProfile = () => ({
    type: CLEAR_PROFILE,
});
